module.exports = __webpack_public_path__ + "media/images/welcome_banner_mobile-3e3f921cc642a67e7d525e0d6cc2b1e1.svg";